import { withAuthenticationRequired } from "@auth0/auth0-react";
import React from "react";
import { useLocation } from "react-router-dom";

export const ProtectedRoute = ({ component }) => {
  const location = useLocation();
  const Component = withAuthenticationRequired(component, {returnTo:location.pathname});
  return <Component />;
};